import { Gift, XCircle } from 'lucide-react'
import { useI18n } from '../i18n/useI18n'
import type { StampMyDraw } from '../services/api'

/**
 * #1871 参加抽選の結果 (当たり / はずれ)。
 *
 * **スキャン直後とラリー画面の両方で同じものを出す。** 引くのは 1 回だけなので、
 * 結果は「その場で見て終わり」ではなく、あとから何度でも確認できる必要がある
 * (当たりのコードを係員に見せるのは列に並んだ後になる)。
 *
 * **はずれも隠さない。** 出さないと「引けたのか分からない」になり、
 * 「自分は抽選されていないのでは」という問い合わせを生む。
 */
export default function LotteryResultCard({ draw }: { draw: StampMyDraw }) {
  const { t } = useI18n()
  const won = draw.result === 'win'
  const redeemed = draw.status === 'redeemed'

  return (
    <div
      className={`rounded-2xl px-4 py-4 text-center ${
        won ? 'bg-gold/10 border border-gold/40' : 'bg-black/5'
      }`}
    >
      <p className="font-body text-[11px] text-text-tertiary">{t('stampRally.lotteryTitle')}</p>
      <div className="mt-1 flex items-center justify-center gap-2">
        {won ? (
          <Gift size={20} className="text-gold" />
        ) : (
          <XCircle size={20} className="text-text-tertiary" />
        )}
        <p className={`font-display text-lg font-semibold ${won ? 'text-navy' : 'text-text-secondary'}`}>
          {won ? t('stampRally.lotteryWin') : t('stampRally.lotteryLose')}
        </p>
      </div>

      {won && draw.code && (
        <>
          {/* 引換コード。**大きく、等幅で出す** — 係員が読み上げ / 手入力する */}
          <p className="mt-2 font-mono text-2xl tracking-widest text-navy">{draw.code}</p>
          <p className="mt-1 font-body text-[11px] text-text-secondary">
            {redeemed ? t('stampRally.lotteryRedeemed') : t('stampRally.lotteryWinNote')}
          </p>
        </>
      )}
    </div>
  )
}
